
// this message is used to request the currently set main print mode from the UI
// mostly used when the Quadient Integrator starts up to know what mode to apply in them

export class MsgRequestCurrentPrintModeMain { }